import React from 'react'
import { GlobalNav } from 'common/GlobalNav'
import { Link, IndexLink } from 'react-router'
import styles from './TwoTierNav.scss'
import cx from 'classnames'

// This is a compatibility/migration tool for Ride Reports pages ONLY
// we need to figure out how to handle subnav in collapsed-mode
export class TwoTierNav extends React.PureComponent {
  render () {
    const { currentUser, secondaryNav } = this.props
    return (
      <div className={styles.TwoTierNav}>
        <GlobalNav currentUser={currentUser} />
        <div className={cx(styles.secondaryNav)}>
          {secondaryNav}
        </div>
      </div>
    )
  }
}

export const NavbarLink = ({ to, ...props }) => (
  <Link to={to} {...props} activeClassName={styles.active} />
)

// this dumbness is resolved by react-router v4
export const NavbarIndexLink = ({ to, ...props }) => (
  <IndexLink to={to} {...props} activeClassName={styles.active} />
)
